import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setdeleteCourse, setloading, seterror, resetdeleteCourse
} from "../reducers/deleteCourseReducer";

const deleteCourseById = (id: any, token: any) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));
    try {
        const result = await api
            .delete(
                `/courses/delete-course/${id}/`,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Token ${token}`
                    },
                }
            )

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setdeleteCourse(result?.data));
            }
            else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
}

export { deleteCourseById, resetdeleteCourse }

